import React from 'react';
import { func, string, object, any } from 'prop-types';
import ExperimentContext from './context';

export { default as createExperimentHook } from './createExperimentHook';

class Experiment extends React.Component {
  constructor(props) {
    super(props);

    if (props.registerExperiment) {
      props.registerExperiment({
        id: props.id,
        baseline: props.baseline,
        variants: props.variants,
      });
    }

    if (!props.id) {
      throw new Error(`Experiment: Missing id property`);
    }

    if (!props.baseline) {
      throw new Error(
        `Experiment: "${this.props.id}" is missing baseline property`
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { registerExperiment } = this.props;
    if (
      registerExperiment &&
      registerExperiment !== prevProps.registerExperiment
    ) {
      registerExperiment({
        id: this.props.id,
        baseline: this.props.baseline,
        variants: this.props.variants,
      });
    }
  }

  render() {
    const { id, render, baseline, variants, selectedVariants } = this.props;
    const variantName =
      selectedVariants &&
      selectedVariants[id] &&
      selectedVariants[id].selectedVariant;

    return render(variants[variantName] || baseline);
  }
}

Experiment.propTypes = {
  registerExperiment: func,
  id: string.isRequired,
  render: func.isRequired,
  baseline: any.isRequired,
  variants: object,
  selectedVariants: object,
};

Experiment.defaultProps = {
  registerExperiment: null,
  variants: {},
  selectedVariants: null,
};

export default props => (
  <ExperimentContext.Consumer>
    {({ selectedVariants, registerExperiment }) => (
      <Experiment
        {...props}
        selectedVariants={selectedVariants}
        registerExperiment={registerExperiment}
      />
    )}
  </ExperimentContext.Consumer>
);
